/* ============================================
   FILTROUS — Collection Filters JS
   Handles: accordion toggle, mobile drawer,
   AJAX filtering (progressive enhancement),
   price range form, browser history.
   ============================================ */
(function () {
  'use strict';

  var LAYOUT_SEL = '[data-fcf-layout]';
  var SIDEBAR_SEL = '[data-fcf-sidebar]';
  var FILTER_LINK_SEL = '[data-fcf-filter-link]';
  var TOGGLE_SEL = '[data-fcf-toggle]';
  var PRICE_FORM_SEL = '[data-fcf-price-form]';
  var ACTIVE_PILLS_SEL = '[data-fcf-active-filters]';
  var GRID_SEL = '[data-product-grid]';
  var COLLECTION_GRID_SEL = '[data-collection-grid]';

  var layout, isAjaxNavigating = false;

  /* ── Init ── */
  function init() {
    layout = document.querySelector(LAYOUT_SEL);
    if (!layout) return;

    bindAccordionToggles();
    bindMobileDrawer();
    bindFilterLinks();
    bindPriceForm();
    bindPopState();
    syncFallbackActiveState();
    sortFilterOptionsNumerically();
  }

  /* ── Sort filter options numerically when values start with numbers ── */
  function sortFilterOptionsNumerically() {
    var groups = document.querySelectorAll('[data-filter-group]');
    for (var i = 0; i < groups.length; i++) {
      var optionsList = groups[i].querySelector('[data-fcf-options]');
      if (!optionsList) continue;

      var items = Array.from(optionsList.querySelectorAll('.fcf__filter-option'));
      if (items.length < 2) continue;

      // Check if most values start with a number
      var numericCount = 0;
      items.forEach(function (li) {
        var text = (li.textContent || '').trim();
        if (/^\d/.test(text)) numericCount++;
      });
      if (numericCount < items.length / 2) continue; // Skip non-numeric filters

      // Sort by leading number
      items.sort(function (a, b) {
        var ta = (a.textContent || '').trim();
        var tb = (b.textContent || '').trim();
        var na = parseFloat(ta) || 0;
        var nb = parseFloat(tb) || 0;
        if (na !== nb) return na - nb;
        return ta.localeCompare(tb);
      });

      // Re-append in sorted order
      items.forEach(function (li) { optionsList.appendChild(li); });
    }
  }


  /* ── Accordion Toggle (dropdown mode) ── */
  function bindAccordionToggles() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest(TOGGLE_SEL);

      if (toggle) {
        var group = toggle.closest('.fcf__filter-group');
        if (!group) return;

        // Close all other open dropdowns first
        var allGroups = document.querySelectorAll('.fcf__filter-group:not(.is-collapsed)');
        allGroups.forEach(function (g) {
          if (g !== group) {
            g.classList.add('is-collapsed');
            var btn = g.querySelector(TOGGLE_SEL);
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });

        group.classList.toggle('is-collapsed');
        var expanded = !group.classList.contains('is-collapsed');
        toggle.setAttribute('aria-expanded', expanded);
        return;
      }

      // Click outside — close all open dropdowns
      if (!e.target.closest('.fcf__filter-group')) {
        var openGroups = document.querySelectorAll('.fcf__filter-group:not(.is-collapsed)');
        openGroups.forEach(function (g) {
          g.classList.add('is-collapsed');
          var btn = g.querySelector(TOGGLE_SEL);
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }


  /* ── Mobile Drawer ── */
  function bindMobileDrawer() {
    var openBtn = document.querySelector('[data-fcf-drawer-open]');
    var drawer = document.querySelector('[data-fcf-drawer]');
    var overlay = document.querySelector('[data-fcf-drawer-overlay]');
    var closeBtn = document.querySelector('[data-fcf-drawer-close]');
    var applyBtn = document.querySelector('[data-fcf-drawer-apply]');

    if (!openBtn || !drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }


  /* ── Close all open filter dropdowns ── */
  function closeAllDropdowns() {
    var openGroups = document.querySelectorAll('.fcf__filter-group:not(.is-collapsed)');
    openGroups.forEach(function (g) {
      g.classList.add('is-collapsed');
      var btn = g.querySelector(TOGGLE_SEL);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }


  /* ── Filter Link Clicks (AJAX Enhancement) ── */
  function bindFilterLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest(FILTER_LINK_SEL);
      if (!link) return;
      if (link.hasAttribute('aria-disabled')) {
        e.preventDefault();
        return;
      }

      // Close dropdown immediately after selecting a filter option
      closeAllDropdowns();

      // ── Fallback filter links: CLIENT-SIDE filtering via data-mf-* attributes ──
      var fbKey = link.getAttribute('data-fcf-fb-key');
      if (fbKey) {
        e.preventDefault();
        var fbValue = link.getAttribute('data-fcf-fb-value');

        // If this is a pill (not a sidebar filter), find and toggle the sidebar link instead
        var isPill = !!link.closest('[data-fcf-fb-pills]') || !!link.closest('[data-fcf-active-filters]');
        if (isPill) {
          // Find matching sidebar link and toggle it
          var sidebarLink = document.querySelector('[data-fcf-fallback] [data-fcf-fb-key="' + fbKey + '"][data-fcf-fb-value="' + fbValue + '"]');
          if (sidebarLink) {
            sidebarLink.classList.remove('is-active');
            var sCheck = sidebarLink.querySelector('.fcf__filter-check');
            if (sCheck) sCheck.classList.remove('is-checked');
          }
          // Also check mobile drawer
          var drawerLink = document.querySelector('[data-fcf-drawer] [data-fcf-fb-key="' + fbKey + '"][data-fcf-fb-value="' + fbValue + '"]');
          if (drawerLink) {
            drawerLink.classList.remove('is-active');
            var dCheck = drawerLink.querySelector('.fcf__filter-check');
            if (dCheck) dCheck.classList.remove('is-checked');
          }
        } else {
          // Toggle active state on the clicked sidebar link + checkbox
          link.classList.toggle('is-active');
          var check = link.querySelector('.fcf__filter-check');
          if (check) check.classList.toggle('is-checked');
        }

        // Collect all active filters: { key: [value1, value2, ...] }
        var activeFilters = {};
        var sidebar = document.querySelector('[data-fcf-fallback]');
        if (sidebar) {
          var activeLinks = sidebar.querySelectorAll('[data-fcf-fb-key].is-active');
          for (var i = 0; i < activeLinks.length; i++) {
            var k = activeLinks[i].getAttribute('data-fcf-fb-key');
            var v = activeLinks[i].getAttribute('data-fcf-fb-value');
            if (!activeFilters[k]) activeFilters[k] = [];
            activeFilters[k].push(v);
          }
        }

        // Also check mobile drawer
        var drawer = document.querySelector('[data-fcf-drawer]');
        if (drawer) {
          var drawerLinks = drawer.querySelectorAll('[data-fcf-fb-key].is-active');
          for (var j = 0; j < drawerLinks.length; j++) {
            var dk = drawerLinks[j].getAttribute('data-fcf-fb-key');
            var dv = drawerLinks[j].getAttribute('data-fcf-fb-value');
            if (!activeFilters[dk]) activeFilters[dk] = [];
            if (activeFilters[dk].indexOf(dv) === -1) activeFilters[dk].push(dv);
          }
        }

        // Filter product cards client-side
        var cards = document.querySelectorAll('.fn-card');
        var visibleCount = 0;
        var activeKeys = Object.keys(activeFilters);

        for (var ci = 0; ci < cards.length; ci++) {
          var card = cards[ci];
          var show = true;

          // Card must match ALL active filter keys (AND logic between keys)
          // Within a key, any value matches (OR logic within key)
          for (var ki = 0; ki < activeKeys.length; ki++) {
            var filterKey = activeKeys[ki];
            var filterValues = activeFilters[filterKey];
            var cardValue = card.getAttribute('data-mf-' + filterKey) || '';

            // Check if card value matches any of the filter values for this key
            var keyMatch = false;
            for (var vi = 0; vi < filterValues.length; vi++) {
              if (cardValue === filterValues[vi]) {
                keyMatch = true;
                break;
              }
            }
            if (!keyMatch) {
              show = false;
              break;
            }
          }

          card.style.display = show ? '' : 'none';
          if (show) visibleCount++;
        }

        // Update product count
        var countEl = document.querySelector('[data-product-count]');
        if (countEl) countEl.textContent = String(visibleCount);

        // Update active filter badge
        var totalActive = activeKeys.reduce(function (sum, k) { return sum + activeFilters[k].length; }, 0);
        var badge = document.querySelector('.fcf__sidebar-badge');
        if (badge) {
          badge.textContent = totalActive > 0 ? String(totalActive) : '';
          badge.style.display = totalActive > 0 ? '' : 'none';
        }

        // Update clear link
        var clearLink = document.querySelector('.fcf__sidebar-clear');
        if (clearLink) {
          clearLink.style.display = totalActive > 0 ? '' : 'none';
        }

        // Build pills
        var pillsContainer = document.querySelector('[data-fcf-fb-pills]');
        if (pillsContainer) {
          var labelMap = {};
          var labelsAttr = (sidebar || document.querySelector('[data-fcf-fb-labels]'));
          if (labelsAttr) {
            var pairs = (labelsAttr.getAttribute('data-fcf-fb-labels') || '').split(',');
            for (var pi = 0; pi < pairs.length; pi++) {
              var pp = pairs[pi].split(':');
              if (pp.length === 2) labelMap[pp[0].trim()] = pp[1].trim();
            }
          }

          var html = '';
          for (var pk = 0; pk < activeKeys.length; pk++) {
            var pKey = activeKeys[pk];
            var pLabel = labelMap[pKey] || pKey.replace(/_/g, ' ').replace(/-/g, ' ');
            var pVals = activeFilters[pKey];
            for (var pv = 0; pv < pVals.length; pv++) {
              html += '<a href="#" class="fcf__pill" data-fcf-filter-link data-fcf-fb-key="' + pKey + '" data-fcf-fb-value="' + pVals[pv].replace(/"/g, '&quot;') + '">';
              html += '<span class="fcf__pill-label">' + pLabel.toUpperCase() + ':</span> ' + pVals[pv];
              html += ' <span class="fcf__pill-x">&times;</span></a>';
            }
          }
          if (totalActive > 0) {
            html += '<a href="#" class="fcf__pill fcf__pill--clear" data-fcf-clear-all>Clear All</a>';
          }
          pillsContainer.innerHTML = html;
        }

        // Update mobile badge
        updateMobileFilterBadge();

        // Update URL (no page reload, just for shareability)
        var url = new URL(window.location.href);
        // Clear old filter params
        var allParams = Array.from(url.searchParams.keys());
        allParams.forEach(function (p) { if (p.startsWith('filter.')) url.searchParams.delete(p); });
        // Add current active filters
        for (var uk = 0; uk < activeKeys.length; uk++) {
          var uKey = activeKeys[uk];
          var uVals = activeFilters[uKey];
          for (var uv = 0; uv < uVals.length; uv++) {
            url.searchParams.append('filter.p.m.custom.' + uKey, uVals[uv]);
          }
        }
        history.replaceState({}, '', url.toString());

        return;
      }

      var href = link.getAttribute('href');
      if (!href) return;

      // Progressive enhancement — try AJAX, fall back to normal navigation
      e.preventDefault();
      navigateWithAjax(href);
    });

    // Clear-all button for client-side filters
    document.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('[data-fcf-clear-all]') || e.target.closest('.fcf__sidebar-clear');
      if (!clearBtn) return;

      // Only intercept if we're in fallback mode
      if (!document.querySelector('[data-fcf-fallback]')) return;

      e.preventDefault();

      // Remove all active states + checkboxes
      var allActive = document.querySelectorAll('[data-fcf-fb-key].is-active');
      for (var i = 0; i < allActive.length; i++) {
        allActive[i].classList.remove('is-active');
        var chk = allActive[i].querySelector('.fcf__filter-check');
        if (chk) chk.classList.remove('is-checked');
      }

      // Show all cards
      var cards = document.querySelectorAll('.fn-card');
      for (var j = 0; j < cards.length; j++) cards[j].style.display = '';

      // Update count
      var countEl = document.querySelector('[data-product-count]');
      if (countEl) countEl.textContent = String(cards.length);

      // Clear pills
      var pills = document.querySelector('[data-fcf-fb-pills]');
      if (pills) pills.innerHTML = '';

      // Clear badge
      var badge = document.querySelector('.fcf__sidebar-badge');
      if (badge) { badge.textContent = ''; badge.style.display = 'none'; }
      var clearLink = document.querySelector('.fcf__sidebar-clear');
      if (clearLink) clearLink.style.display = 'none';

      // Reset URL
      var url = new URL(window.location.href);
      var allParams = Array.from(url.searchParams.keys());
      allParams.forEach(function (p) { if (p.startsWith('filter.')) url.searchParams.delete(p); });
      history.replaceState({}, '', url.toString());

      updateMobileFilterBadge();
    });
  }


  /* ── Price Range Form ── */
  function bindPriceForm() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest(PRICE_FORM_SEL);
      if (!form) return;

      e.preventDefault();

      // Build URL with price params
      var url = new URL(window.location.href);
      var inputs = form.querySelectorAll('input[type="number"]');
      inputs.forEach(function (input) {
        var name = input.name;
        var value = input.value;
        if (name && value) {
          // Shopify expects price in cents
          url.searchParams.set(name, (parseFloat(value) * 100).toString());
        } else if (name) {
          url.searchParams.delete(name);
        }
      });

      // Remove page param when filtering
      url.searchParams.delete('page');

      navigateWithAjax(url.toString());
    });
  }


  /* ── AJAX Navigation ── */
  function navigateWithAjax(url) {
    if (isAjaxNavigating) return;
    isAjaxNavigating = true;

    layout.classList.add('is-loading');

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Detect fallback mode before replacing content
        var isFallbackMode = !!document.querySelector('[data-fcf-fallback]');

        // Update product grid / main content
        var newGrid = doc.querySelector(COLLECTION_GRID_SEL);
        var currentGrid = document.querySelector(COLLECTION_GRID_SEL);
        if (newGrid && currentGrid) {
          var newMain = doc.querySelector('.fcf__main');
          var currentMain = document.querySelector('.fcf__main');
          if (newMain && currentMain) {
            currentMain.innerHTML = newMain.innerHTML;
          } else {
            currentGrid.innerHTML = newGrid.innerHTML;
          }
        }

        if (isFallbackMode) {
          // ── Fallback mode: preserve sidebar, rebuild pills container ──
          // Don't replace sidebar — keep all filter options from initial page load
          // This prevents issues when AJAX response intermittently returns native filters

          // Remove any pills container (may be native from AJAX response)
          var existingPills = document.querySelector(ACTIVE_PILLS_SEL);
          if (existingPills) existingPills.remove();

          // Create fresh fallback pills container (syncFallbackActiveState will fill it)
          var mainEl = document.querySelector('.fcf__main');
          if (mainEl) {
            var pillsEl = document.createElement('div');
            pillsEl.className = 'fcf__pills';
            pillsEl.setAttribute('data-fcf-active-filters', '');
            pillsEl.setAttribute('data-fcf-fb-pills', '');
            mainEl.insertBefore(pillsEl, mainEl.firstChild);
          }

          // Don't replace mobile drawer — keep fallback filter content
        } else {
          // ── Native mode: replace sidebar, pills, drawer as normal ──
          var newSidebar = doc.querySelector(SIDEBAR_SEL);
          var currentSidebar = document.querySelector(SIDEBAR_SEL);
          if (newSidebar && currentSidebar) {
            currentSidebar.innerHTML = newSidebar.innerHTML;
          }

          var newPills = doc.querySelector(ACTIVE_PILLS_SEL);
          var currentPills = document.querySelector(ACTIVE_PILLS_SEL);
          if (currentPills) {
            if (newPills) {
              currentPills.outerHTML = newPills.outerHTML;
            } else {
              currentPills.outerHTML = '<div class="fcf__pills" data-fcf-active-filters></div>';
            }
          }

          var newDrawerBody = doc.querySelector('[data-fcf-drawer] .fcf__drawer-body');
          var currentDrawerBody = document.querySelector('[data-fcf-drawer] .fcf__drawer-body');
          if (newDrawerBody && currentDrawerBody) {
            currentDrawerBody.innerHTML = newDrawerBody.innerHTML;
          }
        }

        // Update mobile filter badge count
        updateMobileFilterBadge();

        // Update product count in toolbar
        var newCount = doc.querySelector('[data-product-count]');
        var currentCount = document.querySelector('[data-product-count]');
        if (newCount && currentCount) {
          currentCount.textContent = newCount.textContent;
        }

        // Update pagination
        var newPagination = doc.querySelector('.fcg__pagination');
        var currentPagination = document.querySelector('.fcg__pagination');
        if (currentPagination) {
          if (newPagination) {
            currentPagination.outerHTML = newPagination.outerHTML;
          } else {
            currentPagination.remove();
          }
        } else if (newPagination) {
          var gridContainer = document.querySelector('.filtrous-container');
          if (gridContainer) gridContainer.appendChild(newPagination);
        }

        // Update URL
        history.pushState({ fcfFilter: true }, '', url);

        // Scroll to top of grid on filter change
        var gridTop = document.querySelector(COLLECTION_GRID_SEL);
        if (gridTop) {
          var rect = gridTop.getBoundingClientRect();
          if (rect.top < 0) {
            window.scrollTo({
              top: window.scrollY + rect.top - 120,
              behavior: 'smooth'
            });
          }
        }

        // Sync fallback filter active states from URL (skip auto-expand — user just closed the dropdown)
        syncFallbackActiveState({ skipExpand: true });

        // Re-init collection.js features (sort, view toggle, load more)
        reinitCollectionFeatures();
      })
      .catch(function (err) {
        console.warn('FCF: AJAX navigation failed, falling back to page navigation', err);
        window.location.href = url;
      })
      .finally(function () {
        isAjaxNavigating = false;
        layout.classList.remove('is-loading');
      });
  }


  /* ── Browser Back/Forward ── */
  function bindPopState() {
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.fcfFilter) {
        navigateWithAjax(window.location.href);
      } else {
        // If no state, just reload the page
        window.location.reload();
      }
    });
  }


  /* ── Update Mobile Filter Badge ── */
  function updateMobileFilterBadge() {
    var badge = document.querySelector('.fcf__mobile-filter-badge');
    if (!badge) return;
    var pills = document.querySelectorAll('.fcf__pill:not(.fcf__pill--clear)');
    var count = pills.length;
    badge.textContent = count > 0 ? count : '';
  }


  /* ── Reinit Collection Features ── */
  function reinitCollectionFeatures() {
    // Re-bind sort dropdowns
    var sortSelects = document.querySelectorAll('[data-sort-select]');
    sortSelects.forEach(function (select) {
      // Clone to remove old listeners
      var clone = select.cloneNode(true);
      select.parentNode.replaceChild(clone, select);
      clone.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', clone.value);
        navigateWithAjax(url.toString());
      });
    });

    // Re-bind view toggle
    var viewBtns = document.querySelectorAll('[data-view]');
    viewBtns.forEach(function (btn) {
      var clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);
      clone.addEventListener('click', function () {
        var view = clone.getAttribute('data-view');
        var grid = document.querySelector('[data-product-grid]');
        if (!grid) return;
        grid.setAttribute('data-view-mode', view);
        document.querySelectorAll('[data-view]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-view') === view);
        });
        try { localStorage.setItem('filtrous_view_pref', view); } catch (e) {}
      });
    });

    // Re-bind load more
    var loadMoreBtn = document.querySelector('[data-load-more]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var nextUrl = loadMoreBtn.getAttribute('data-next-url');
        if (!nextUrl) return;
        loadMoreBtn.classList.add('is-loading');
        loadMoreBtn.disabled = true;

        fetch(nextUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newCards = doc.querySelectorAll('[data-product-grid] .fn-card');
            var grid = document.querySelector('[data-product-grid]');
            if (grid && newCards.length) {
              newCards.forEach(function (card) { grid.appendChild(card); });
            }
            // Update load more button
            var newLoadMore = doc.querySelector('[data-load-more]');
            if (newLoadMore) {
              loadMoreBtn.setAttribute('data-next-url', newLoadMore.getAttribute('data-next-url'));
              var countSpan = loadMoreBtn.querySelector('.fcg__load-more-count');
              var newCountSpan = newLoadMore.querySelector('.fcg__load-more-count');
              if (countSpan && newCountSpan) {
                countSpan.textContent = newCountSpan.textContent;
              }
            } else {
              loadMoreBtn.remove();
            }
          })
          .catch(function () {
            window.location.href = nextUrl;
          })
          .finally(function () {
            loadMoreBtn.classList.remove('is-loading');
            loadMoreBtn.disabled = false;
          });
      });
    }
  }


  /* ── Fallback Filter: Sync Active State from URL ── */
  function syncFallbackActiveState(opts) {
    opts = opts || {};
    var sidebar = document.querySelector('[data-fcf-fallback]');
    if (!sidebar) return;

    var params = new URLSearchParams(window.location.search);
    var activeCount = 0;
    var activeFilters = []; // For generating pills

    // Build label map from data attribute
    var labelMap = {};
    var labelStr = sidebar.getAttribute('data-fcf-fb-labels') || '';
    labelStr.split(',').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) labelMap[parts[0].trim()] = parts[1].trim();
    });

    // Mark active filter options (detect variant option vs metafield)
    var links = sidebar.querySelectorAll('[data-fcf-fb-key]');
    links.forEach(function (link) {
      var key = link.getAttribute('data-fcf-fb-key');
      var value = link.getAttribute('data-fcf-fb-value');
      var fbType = link.getAttribute('data-fcf-fb-type');
      var paramName = (fbType === 'variant_option') ? 'filter.v.option.' + key : 'filter.p.m.custom.' + key;
      var isActive = params.getAll(paramName).indexOf(value) !== -1;

      link.classList.toggle('is-active', isActive);
      var check = link.querySelector('.fcf__filter-check');
      if (check) check.classList.toggle('is-checked', isActive);

      if (isActive) {
        activeCount++;
        activeFilters.push({ key: key, value: value, label: labelMap[key] || key, type: fbType || 'metafield' });
        // Only auto-expand on initial page load, not during AJAX navigation
        if (!opts.skipExpand) {
          var group = link.closest('.fcf__filter-group');
          if (group && group.classList.contains('is-collapsed')) {
            group.classList.remove('is-collapsed');
            var btn = group.querySelector(TOGGLE_SEL);
            if (btn) btn.setAttribute('aria-expanded', 'true');
          }
        }
      }
    });

    // Update badge
    var badge = sidebar.querySelector('.fcf-fb-badge-placeholder');
    if (badge) {
      badge.textContent = activeCount > 0 ? activeCount : '';
      badge.style.display = activeCount > 0 ? '' : 'none';
    }

    // Update clear-all link
    var clearLink = sidebar.querySelector('.fcf-fb-clear-placeholder');
    if (clearLink) {
      clearLink.style.display = activeCount > 0 ? '' : 'none';
    }

    // Generate fallback filter pills
    var pillsContainer = document.querySelector('[data-fcf-fb-pills]');
    if (pillsContainer) {
      if (activeFilters.length === 0) {
        pillsContainer.innerHTML = '';
        return;
      }
      var html = '';
      activeFilters.forEach(function (f) {
        html += '<a href="#" class="fcf__pill" data-fcf-filter-link data-fcf-fb-key="' + f.key + '" data-fcf-fb-value="' + f.value.replace(/"/g, '&quot;') + '" data-fcf-fb-type="' + f.type + '">';
        html += '<span class="fcf__pill-group">' + f.label + ':</span> ';
        html += '<span class="fcf__pill-label">' + f.value + '</span>';
        html += '<svg class="fcf__pill-remove" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3.5 3.5l7 7M10.5 3.5l-7 7"/></svg>';
        html += '</a>';
      });
      if (activeFilters.length > 1) {
        var collectionUrl = sidebar.querySelector('.fcf-fb-clear-placeholder');
        var clearHref = collectionUrl ? collectionUrl.getAttribute('href') : window.location.pathname;
        html += '<a href="' + clearHref + '" class="fcf__pill fcf__pill--clear" data-fcf-filter-link>Clear All</a>';
      }
      pillsContainer.innerHTML = html;
    }
  }


  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
